module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.propWrapperSize,
    attrs: {
      "id": "vbar"
    }
  }, [_c('div', {
    ref: "container",
    staticClass: "bar--container",
    on: {
      "wheel": _vm.scroll,
      "touchmove": _vm.scroll
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bars.vertical.size),
      expression: "bars.vertical.size"
    }],
    ref: "verticalBar",
    staticClass: "bar--vertical",
    class: _vm.propBarVertical,
    style: (_vm.barSizeVertical),
    attrs: {
      "data-axis": "Y",
      "data-drag-source": "bar"
    },
    on: {
      "touchstart": _vm.startDrag,
      "mousedown": _vm.startDrag
    }
  }, [_c('div', {
    ref: "verticalInternalBar",
    staticClass: "bar--vertical-internal",
    class: _vm.propBarInternalVertical,
    style: (_vm.barInternalVertical),
    attrs: {
      "data-axis": "Y",
      "data-drag-source": "internal"
    },
    on: {
      "touchstart": _vm.startDrag,
      "mousedown": _vm.startDrag
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bars.horizontal.size),
      expression: "bars.horizontal.size"
    }],
    staticClass: "bar--horizontal",
    class: _vm.propBarHorizontal,
    style: (_vm.barSizeHorizontal),
    attrs: {
      "data-axis": "X",
      "data-drag-source": "bar"
    },
    on: {
      "touchstart": _vm.startDrag,
      "mousedown": _vm.startDrag
    }
  }, [_c('div', {
    ref: "horizontalBar",
    staticClass: "bar--horizontal-internal",
    class: _vm.propBarInternalHorizontal,
    style: (_vm.barInternalHorizontal),
    attrs: {
      "data-axis": "X",
      "data-drag-source": "internal"
    },
    on: {
      "touchstart": _vm.startDrag,
      "mousedown": _vm.startDrag
    }
  })]), _c('div', {
    ref: "wrapperRef",
    staticClass: "bar--wrapper",
    style: (_vm.validationScrolls)
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7740dc4f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-bar.vue
// module id = 12
// module chunks = 0